module.exports = __webpack_public_path__ + "static/media/hatchet.e9365d0b.svg";